import { cleanupObject } from '.';
import { getAPIUrl } from '../helpers/App';
import { isAllFilesPage } from '../helpers/Files';

let getRelatedFilesRequestCancel = null;
export const APIgetFiles = (params) => {
  if (isAllFilesPage() && window.getCollectionsRequestCancel !== null) {
    window.getCollectionsRequestCancel.cancel('Operation canceled due to new request.');
    window.getCollectionsRequestCancel = null;
  }
  if (params.fileUuid) {
    if (getRelatedFilesRequestCancel !== null) {
      getRelatedFilesRequestCancel.cancel('Operation canceled due to new request.');
    }
    getRelatedFilesRequestCancel = window.axios.CancelToken.source();
  } else if (params.only_filters) {
    if (window.getFiltersRequestCancel !== null) {
      window.getFiltersRequestCancel.cancel('Operation canceled due to new request.');
    }
    window.getFiltersRequestCancel = window.axios.CancelToken.source();
  } else {
    if (window.getFilesRequestCancel !== null) {
      window.getFilesRequestCancel.cancel('Operation canceled due to new request.');
    }
    window.getFilesRequestCancel = window.axios.CancelToken.source();
  }

  let cancelToken = null;
  if (params.fileUuid) {
    cancelToken = getRelatedFilesRequestCancel.token;
  } else if (params.only_filters) {
    cancelToken = window.getFiltersRequestCancel.token;
  } else {
    cancelToken = window.getFilesRequestCancel.token;
  }
  return window.axios.get(getAPIUrl('/files'), {
    cancelToken,
    params,
  })
    .then(response => (response));
};

export const APIgetFilesAsync = params => (
  window.axios.get(getAPIUrl('/files'), {
    params,
  }).then(response => (response))
);

export const APIgetFilesList = params => (
  window.axios.get(getAPIUrl('/files/list'), { params })
    .then(response => (response))
);

export const APIgetFile = fileUuid => (
  window.axios.get(getAPIUrl(`/files/${fileUuid}`))
    .then(response => (response))
);

export const APIgetFileEmbed = fileUuid => (
  window.axios.get(getAPIUrl(`/files/${fileUuid}/embed`))
    .then(response => (response))
);

export const APIchangeFileThumbnail = (fileUuid, thumbnailPathUuid) => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/thumbnail`), {
    thumbnail_path: thumbnailPathUuid,
  }).then(response => (response))
);

export const APIrefreshFileThumbnail = (fileUuid) => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/thumbnail/refresh`)).then(response => (response))
);

export const APIremoveFileThumbnail = fileUuid => (
  window.axios.delete(getAPIUrl(`/files/${fileUuid}/thumbnail`))
    .then(response => (response))
);

export const APIremoveFileBackground = (formData) => (
  window.axios.post(
    getAPIUrl(`/files/remove_background`),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    },
  ).then(response => (response))
);

export const APIperformFileAIAction = (formData) => (
  window.axios.post(
    getAPIUrl(`/files/perform_ai_action`),
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob',
    },
  ).then(response => (response))
);

export const APIcreateFile = file => (
  window.axios.post(getAPIUrl('/files'), { file })
    .then(response => (response))
);

export const APIupdateFile = file => (
  window.axios.patch(getAPIUrl(`/files/${file.uuid}`), { file: cleanupObject(file) })
    .then(response => (response))
);

export const APIdeleteFile = (fileUuid, params = {}) => (
  window.axios.delete(getAPIUrl(`/files/${fileUuid}`), { params })
    .then(response => (response))
);

export const APIdeleteFiles = ({
  files,
  fileParams,
  fileGroupUuid,
  selectedAllFiles,
  filters,
  progressGroupUuid,
}) => (
  window.axios.post(getAPIUrl('/files/batch_delete'), {
    files,
    fileParams,
    file_group_uuid: fileGroupUuid,
    selected_all: !!selectedAllFiles,
    filters,
    progress_group_uuid: progressGroupUuid,
  })
    .then(response => (response))
);

export const APIdeleteFilePermanent = (fileUuid, params = {}) => (
  window.axios.delete(getAPIUrl(`/files/${fileUuid}/permanent`), { params })
    .then(response => (response))
);

export const APIdeleteFilesPermanent = ({
  files,
  fileParams,
  fileGroupUuid,
  selectedAllFiles,
  filters,
  progressGroupUuid,
}) => (
  window.axios.post(getAPIUrl('/files/batch_delete_permanent'), {
    files,
    fileParams,
    file_group_uuid: fileGroupUuid,
    selected_all: !!selectedAllFiles,
    filters,
    progress_group_uuid: progressGroupUuid,
  })
    .then(response => (response))
);

export const APIrestoreDeletedFile = (fileUuid, params = {}) => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/restore`), { params })
    .then(response => (response))
);

export const APIrestoreDeletedFiles = ({
  files,
  fileParams,
  fileGroupUuid,
  selectedAllFiles,
  filters,
  progressGroupUuid,
}) => (
  window.axios.post(getAPIUrl('/files/batch_restore'), {
    files,
    fileParams,
    file_group_uuid: fileGroupUuid,
    selected_all: !!selectedAllFiles,
    filters,
    progress_group_uuid: progressGroupUuid,
  })
    .then(response => (response))
);

export const APIcreateFileVersion = (fileUuid, params) => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/versions`), params)
    .then(response => (response))
);

export const APIdeleteFileVersion = (fileUuid, versionId) => (
  window.axios.delete(getAPIUrl(`/files/${fileUuid}/versions/${versionId}`))
    .then(response => (response))
);

export const APIrestoreFileVersion = (fileUuid, versionId) => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/versions/${versionId}/restore`))
    .then(response => (response))
);

export const APIgetFileStatuses = params => (
  window.axios.get(getAPIUrl('/files/statuses'), { params })
    .then(response => (response))
);

export const APIcreateFileStatus = status => (
  window.axios.post(getAPIUrl('/files/statuses'), { status })
    .then(response => (response))
);

export const APIupdateFileStatus = status => (
  window.axios.patch(getAPIUrl(`/files/statuses/${status.id}`), { status })
    .then(response => (response))
);

export const APIdeleteFileStatus = statusId => (
  window.axios.delete(getAPIUrl(`/files/statuses/${statusId}`))
    .then(response => (response))
);

export const APIgetFileSizes = params => (
  window.axios.get(getAPIUrl('/files/sizes'), { params })
    .then(response => (response))
);

export const APIcreateFileSize = size => (
  window.axios.post(getAPIUrl('/files/sizes'), { size })
    .then(response => (response))
);

export const APIupdateFileSize = size => (
  window.axios.patch(getAPIUrl(`/files/sizes/${size.id}`), { size })
    .then(response => (response))
);

export const APIdeleteFileSize = sizeId => (
  window.axios.delete(getAPIUrl(`/files/sizes/${sizeId}`))
    .then(response => (response))
);

export const APIupdateFileOwner = (fileUuid, userUuid) => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/owner`), { user_uuid: userUuid })
    .then(response => (response))
);

export const APIgetFileLikes = fileUuid => (
  window.axios.get(getAPIUrl(`/files/${fileUuid}/likes`))
    .then(response => (response))
);

export const APIlikeFile = fileUuid => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/likes`))
    .then(response => (response))
);

export const APIunlikeFile = fileUuid => (
  window.axios.delete(getAPIUrl(`/files/${fileUuid}/likes`))
    .then(response => (response))
);

export const APIgetFilesWithPermissions = params => (
  window.axios.post(getAPIUrl('/files/permissions'), params)
    .then(response => (response))
);

export const APIupdateFilePermissions = file => (
  window.axios.patch(getAPIUrl(`/files/${file.uuid}/permissions`), { file })
    .then(response => (response))
    .catch(error => (error))
);

let getFileCollectionsRequestCancel = null;
export const APIgetFileCollections = (fileUuid) => {
  if (getFileCollectionsRequestCancel !== null) {
    getFileCollectionsRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileCollectionsRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/files/${fileUuid}/collections`), {
    cancelToken: getFileCollectionsRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

let getFileLogRequestCancel = null;
export const APIgetFileLog = (fileUuid) => {
  if (getFileLogRequestCancel !== null) {
    getFileLogRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileLogRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/files/${fileUuid}/log`), {
    cancelToken: getFileLogRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

let getFileInfoRequestCancel = null;
export const APIgetFileInfo = (fileUuid) => {
  if (getFileInfoRequestCancel !== null) {
    getFileInfoRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileInfoRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/files/${fileUuid}/info`), {
    cancelToken: getFileInfoRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

let getFileCommentsRequestCancel = null;
export const APIgetFileComments = (fileUuid) => {
  if (getFileCommentsRequestCancel !== null) {
    getFileCommentsRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileCommentsRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/files/${fileUuid}/comments`), {
    cancelToken: getFileCommentsRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

export const APIgetShareFileComments = (shareUuid, fileUuid) => {
  if (getFileCommentsRequestCancel !== null) {
    getFileCommentsRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileCommentsRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/comments`), {
    cancelToken: getFileCommentsRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

export const APIgetFileVersionComments = (fileUuid, fileVersionUuid) => {
  if (getFileCommentsRequestCancel !== null) {
    getFileCommentsRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileCommentsRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/files/${fileUuid}/versions/${fileVersionUuid}/comments`), {
    cancelToken: getFileCommentsRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

export const APIgetShareFileVersionComments = (shareUuid, fileUuid, fileVersion) => {
  if (getFileCommentsRequestCancel !== null) {
    getFileCommentsRequestCancel.cancel('Operation canceled due to new request.');
  }
  getFileCommentsRequestCancel = window.axios.CancelToken.source();

  return window.axios.get(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/versions/${fileVersion}/comments`), {
    cancelToken: getFileCommentsRequestCancel.token,
  })
    .then(response => (response))
    .catch(error => (error));
};

export const APIcopyFileVersionComments = (fileUuid, fileVersionUuid, params) => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/versions/${fileVersionUuid}/comments/copy`), { ...params })
    .then(response => (response))
);

export const APIcreateFileComment = (fileUuid, comment) => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/comments`), { comment })
    .then(response => (response))
);

export const APIcreateShareFileComment = (shareUuid, fileUuid, comment) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/comments`), { comment })
    .then(response => (response))
);

export const APIupdateFileComment = comment => (
  window.axios.patch(getAPIUrl(`/comments/${comment.id}`), { comment })
    .then(response => (response))
);

export const APIupdateShareFileComment = (shareUuid, fileUuid, comment) => (
  window.axios.patch(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/comments/${comment.id}`), { comment })
    .then(response => (response))
);

export const APIdeleteFileComment = commentId => (
  window.axios.delete(getAPIUrl(`/comments/${commentId}`))
    .then(response => (response))
);

export const APIdeleteShareFileComment = (shareUuid, fileUuid, commentId) => (
  window.axios.delete(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/comments/${commentId}`))
    .then(response => (response))
);

export const APIsubscribeFile = fileUuid => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/subscribe`))
    .then(response => (response))
);

export const APIsubscribeShareFile = (shareUuid, fileUuid) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/subscribe`))
    .then(response => (response))
);

export const APIunsubscribeFile = fileUuid => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/unsubscribe`))
    .then(response => (response))
);

export const APIunsubscribeShareFile = (shareUuid, fileUuid) => (
  window.axios.post(getAPIUrl(`/shares/${shareUuid}/files/${fileUuid}/unsubscribe`))
    .then(response => (response))
);

export const APIregisterFileView = fileUuid => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/views`))
    .then(response => (response))
);

export const APIarchiveFile = fileUuid => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/archive`))
    .then(response => (response))
    .catch(error => (error))
);

export const APIunarchiveFile = fileUuid => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/unarchive`))
    .then(response => (response))
    .catch(error => (error))
);

export const APIgetActivity = params => (
  window.axios.get(getAPIUrl('/activity'), { params })
    .then(response => (response))
);

export const APIgetFilesGroups = params => (
  window.axios.get(getAPIUrl('/file_groups'), { params })
    .then(response => (response))
);

export const APIgetFilesGroup = filesGroupUuid => (
  window.axios.get(getAPIUrl(`/file_groups/${filesGroupUuid}`))
    .then(response => (response))
);

export const APIcreateFilesGroup = params => (
  window.axios.post(getAPIUrl('/file_groups'), { params })
    .then(response => (response))
);

export const APIfinishFilesGroup = (filesGroupUuid, params = {}) => (
  window.axios.post(getAPIUrl(`/file_groups/${filesGroupUuid}/finish`), { params })
    .then(response => (response))
);

export const APIgetFilesGroupFiles = (filesGroupUuid, params) => (
  window.axios.get(getAPIUrl(`/file_groups/${filesGroupUuid}/files`), { params })
    .then(response => (response))
);

export const APIgetFilesGroupsUsers = params => (
  window.axios.get(getAPIUrl('/file_groups/users'), { params })
    .then(response => (response))
);

export const APIgetFilePreview = (file, params) => (
  window.axios.post(getAPIUrl('/preview'), { file, ...params })
    .then(response => (response))
);

export const APIgetFilePublicUrl = (fileUuid, params = {}) => (
  window.axios.get(getAPIUrl(`/files/${fileUuid}/public`), { params })
    .then(response => (response))
);

export const APIgetWebsites = () => (
  window.axios.get(getAPIUrl('/files/websites'))
    .then(response => (response))
);

export const APIgetDuplicates = params => (
  window.axios.get(getAPIUrl('/duplicates'), { params })
    .then(response => (response))
);

export const APIgetAllDuplicates = params => (
  window.axios.get(getAPIUrl('/duplicates/all'), { params })
    .then(response => (response))
);

export const APIgetDuplicate = duplicateUuid => (
  window.axios.get(getAPIUrl(`/duplicates/${duplicateUuid}`))
    .then(response => (response))
);

export const APImergeDuplicate = (duplicateUuid, params) => (
  window.axios.post(getAPIUrl(`/duplicates/${duplicateUuid}/merge`), params)
    .then(response => (response))
);

export const APIbulkMergeDuplicate = (duplicateUuid) => (
  window.axios.post(getAPIUrl(`/duplicates/${duplicateUuid}/bulk_merge`))
    .then(response => (response))
);

export const APIdeleteDuplicate = duplicateUuid => (
  window.axios.delete(getAPIUrl(`/duplicates/${duplicateUuid}`))
    .then(response => (response))
);

export const APIhideDuplicate = duplicateUuid => (
  window.axios.patch(getAPIUrl(`/duplicates/${duplicateUuid}/hide`))
    .then(response => (response))
);

export const APIunhideDuplicate = duplicateUuid => (
  window.axios.patch(getAPIUrl(`/duplicates/${duplicateUuid}/unhide`))
    .then(response => (response))
);

export const APIgetFileEditions = (fileUuid) => (
  window.axios.get(getAPIUrl(`/files/${fileUuid}/editions`))
    .then(response => (response))
);

export const APIconvertFile = (fileUuid, params) => (
  window.axios.post(getAPIUrl(`/files/${fileUuid}/convert`), params)
    .then(response => (response.data))
);

export const APIupdateFileExtraFields = (fileUuid, fields) => (
  window.axios.patch(getAPIUrl(`/files/${fileUuid}/extra_fields`), { fields })
    .then(response => (response.data))
);
